var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1674390274859,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 10660,
    width: 120,
    height: 170,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.333333 290.773333L0 832h618.666667L309.333333 290.773333z",
    fill: "#3949AB",
    "p-id": 10661
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.56 426.026667l18.773333 38.613333 18.773334-38.613333 43.946666 24.96-62.72-102.4-51.413333 87.68 32.64-10.24z",
    fill: "#7986CB",
    "p-id": 10662
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M789.333333 448L554.666667 832h469.333333L789.333333 448z",
    fill: "#5C6BC0",
    "p-id": 10663
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512 192L170.666667 832h682.666666L512 192z",
    fill: "#7986CB",
    "p-id": 10664
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M432.426667 405.333333l15.573333 85.333334 42.666667-106.666667 42.666666 64 21.333334-64 36.906666 21.333333L512 256l-79.573333 149.333333z",
    fill: "#BBDEFB",
    "p-id": 10665
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M769.28 590.08l20.906667 42.666667 21.12-42.666667 49.28 27.52-70.4-112.853333-57.6 96.426666 36.693333-11.093333z",
    fill: "#9FA8DA",
    "p-id": 10666
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceIcon);
export default __webpack_public_path__ + "static/media/iceIcon.70a0a48bce1dcea77f6bc882273c43d1.svg";
export { ForwardRef as ReactComponent };